// src/contract.ts
var contract = [
  {
    prim: "storage",
    args: [
      {
        prim: "pair",
        args: [
          {
            prim: "address",
            annots: ["%owner"]
          },
          {
            prim: "pair",
            args: [
              {
                prim: "set",
                args: [
                  {
                    prim: "address"
                  }
                ],
                annots: ["%signers"]
              },
              {
                prim: "pair",
                args: [
                  {
                    prim: "nat",
                    annots: ["%threshold"]
                  },
                  {
                    prim: "pair",
                    args: [
                      {
                        prim: "nat",
                        annots: ["%last_op_id"]
                      },
                      {
                        prim: "pair",
                        args: [
                          {
                            prim: "big_map",
                            args: [
                              {
                                prim: "nat"
                              },
                              {
                                prim: "pair",
                                args: [
                                  {
                                    prim: "lambda",
                                    args: [
                                      {
                                        prim: "unit"
                                      },
                                      {
                                        prim: "list",
                                        args: [
                                          {
                                            prim: "operation"
                                          }
                                        ]
                                      }
                                    ],
                                    annots: ["%actions"]
                                  },
                                  {
                                    prim: "set",
                                    args: [
                                      {
                                        prim: "address"
                                      }
                                    ],
                                    annots: ["%approvals"]
                                  }
                                ]
                              }
                            ],
                            annots: ["%pending_ops"]
                          },
                          {
                            prim: "big_map",
                            args: [
                              {
                                prim: "string"
                              },
                              {
                                prim: "bytes"
                              }
                            ],
                            annots: ["%metadata"]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    prim: "parameter",
    args: [
      {
        prim: "or",
        args: [
          {
            prim: "or",
            args: [
              {
                prim: "or",
                args: [
                  {
                    prim: "bytes",
                    annots: ["%set_metadata_uri"]
                  },
                  {
                    prim: "unit",
                    annots: ["%default"]
                  }
                ]
              },
              {
                prim: "or",
                args: [
                  {
                    prim: "lambda",
                    args: [
                      {
                        prim: "unit"
                      },
                      {
                        prim: "list",
                        args: [
                          {
                            prim: "operation"
                          }
                        ]
                      }
                    ],
                    annots: ["%propose"]
                  },
                  {
                    prim: "nat",
                    annots: ["%approve"]
                  }
                ]
              }
            ]
          },
          {
            prim: "nat",
            annots: ["%execute"]
          }
        ]
      }
    ]
  },
  {
    prim: "code",
    args: [
      [
        {
          prim: "NIL",
          args: [
            {
              prim: "operation"
            }
          ]
        },
        {
          prim: "DIG",
          args: [
            {
              int: "1"
            }
          ]
        },
        {
          prim: "UNPAIR"
        },
        {
          prim: "DIP",
          args: [
            {
              int: "1"
            },
            [
              {
                prim: "UNPAIR",
                args: [
                  {
                    int: "6"
                  }
                ]
              }
            ]
          ]
        },
        {
          prim: "IF_LEFT",
          args: [
            [
              {
                prim: "IF_LEFT",
                args: [
                  [
                    {
                      prim: "IF_LEFT",
                      args: [
                        [
                          {
                            prim: "DUP",
                            args: [
                              {
                                int: "2"
                              }
                            ]
                          },
                          {
                            prim: "SENDER"
                          },
                          {
                            prim: "COMPARE"
                          },
                          {
                            prim: "EQ"
                          },
                          {
                            prim: "NOT"
                          },
                          {
                            prim: "IF",
                            args: [
                              [
                                {
                                  prim: "PUSH",
                                  args: [
                                    {
                                      prim: "string"
                                    },
                                    {
                                      string: "INVALID_CALLER"
                                    }
                                  ]
                                },
                                {
                                  prim: "FAILWITH"
                                }
                              ],
                              []
                            ]
                          },
                          {
                            prim: "DUP",
                            args: [
                              {
                                int: "7"
                              }
                            ]
                          },
                          {
                            prim: "DUP",
                            args: [
                              {
                                int: "2"
                              }
                            ]
                          },
                          {
                            prim: "SOME"
                          },
                          {
                            prim: "PUSH",
                            args: [
                              {
                                prim: "string"
                              },
                              {
                                string: ""
                              }
                            ]
                          },
                          {
                            prim: "UPDATE"
                          },
                          {
                            prim: "DIP",
                            args: [
                              {
                                int: "1"
                              },
                              [
                                {
                                  prim: "DIG",
                                  args: [
                                    {
                                      int: "6"
                                    }
                                  ]
                                },
                                {
                                  prim: "DROP",
                                  args: [
                                    {
                                      int: "1"
                                    }
                                  ]
                                }
                              ]
                            ]
                          },
                          {
                            prim: "DUG",
                            args: [
                              {
                                int: "6"
                              }
                            ]
                          },
                          {
                            prim: "DROP",
                            args: [
                              {
                                int: "1"
                              }
                            ]
                          },
                          {
                            prim: "PAIR",
                            args: [
                              {
                                int: "6"
                              }
                            ]
                          },
                          {
                            prim: "DIG",
                            args: [
                              {
                                int: "1"
                              }
                            ]
                          },
                          {
                            prim: "PAIR"
                          }
                        ],
                        [
                          {
                            prim: "DROP",
                            args: [
                              {
                                int: "1"
                              }
                            ]
                          },
                          {
                            prim: "DUP",
                            args: [
                              {
                                int: "3"
                              }
                            ]
                          },
                          {
                            prim: "DUP",
                            args: [
                              {
                                int: "3"
                              }
                            ]
                          },
                          {
                            prim: "SIZE"
                          },
                          {
                            prim: "COMPARE"
                          },
                          {
                            prim: "GE"
                          },
                          {
                            prim: "NOT"
                          },
                          {
                            prim: "IF",
                            args: [
                              [
                                {
                                  prim: "PUSH",
                                  args: [
                                    {
                                      prim: "string"
                                    },
                                    {
                                      string: "FUNDING BLOCKED SINCE PARAMS ARE INVALID"
                                    }
                                  ]
                                },
                                {
                                  prim: "FAILWITH"
                                }
                              ],
                              []
                            ]
                          },
                          {
                            prim: "PAIR",
                            args: [
                              {
                                int: "6"
                              }
                            ]
                          },
                          {
                            prim: "DIG",
                            args: [
                              {
                                int: "1"
                              }
                            ]
                          },
                          {
                            prim: "PAIR"
                          }
                        ]
                      ]
                    }
                  ],
                  [
                    {
                      prim: "IF_LEFT",
                      args: [
                        [
                          {
                            prim: "PUSH",
                            args: [
                              {
                                prim: "mutez"
                              },
                              {
                                int: "0"
                              }
                            ]
                          },
                          {
                            prim: "AMOUNT"
                          },
                          {
                            prim: "COMPARE"
                          },
                          {
                            prim: "EQ"
                          },
                          {
                            prim: "NOT"
                          },
                          {
                            prim: "IF",
                            args: [
                              [
                                {
                                  prim: "PUSH",
                                  args: [
                                    {
                                      prim: "string"
                                    },
                                    {
                                      string: "TO FUND CONTRACT, PLEASE USE THE DEFAULT ENTRYPOINT"
                                    }
                                  ]
                                },
                                {
                                  prim: "FAILWITH"
                                }
                              ],
                              []
                            ]
                          },
                          {
                            prim: "DUP",
                            args: [
                              {
                                int: "3"
                              }
                            ]
                          },
                          {
                            prim: "SENDER"
                          },
                          {
                            prim: "MEM"
                          },
                          {
                            prim: "NOT"
                          },
                          {
                            prim: "IF",
                            args: [
                              [
                                {
                                  prim: "PUSH",
                                  args: [
                                    {
                                      prim: "string"
                                    },
                                    {
                                      string: "ONLY FOR SIGNERS"
                                    }
                                  ]
                                },
                                {
                                  prim: "FAILWITH"
                                }
                              ],
                              []
                            ]
                          },
                          {
                            prim: "PUSH",
                            args: [
                              {
                                prim: "nat"
                              },
                              {
                                int: "1"
                              }
                            ]
                          },
                          {
                            prim: "DUP",
                            args: [
                              {
                                int: "6"
                              }
                            ]
                          },
                          {
                            prim: "ADD"
                          },
                          {
                            prim: "DIP",
                            args: [
                              {
                                int: "1"
                              },
                              [
                                {
                                  prim: "DIG",
                                  args: [
                                    {
                                      int: "4"
                                    }
                                  ]
                                },
                                {
                                  prim: "DROP",
                                  args: [
                                    {
                                      int: "1"
                                    }
                                  ]
                                }
                              ]
                            ]
                          },
                          {
                            prim: "DUG",
                            args: [
                              {
                                int: "4"
                              }
                            ]
                          },
                          {
                            prim: "DUP",
                            args: [
                              {
                                int: "6"
                              }
                            ]
                          },
                          {
                            prim: "DUP",
                            args: [
                              {
                                int: "6"
                              }
                            ]
                          },
                          {
                            prim: "MEM"
                          },
                          {
                            prim: "IF",
                            args: [
                              [
                                {
                                  prim: "PUSH",
                                  args: [
                                    {
                                      prim: "string"
                                    },
                                    {
                                      string: "pending_ops"
                                    }
                                  ]
                                },
                                {
                                  prim: "PUSH",
                                  args: [
                                    {
                                      prim: "string"
                                    },
                                    {
                                      string: "KEY_EXISTS"
                                    }
                                  ]
                                },
                                {
                                  prim: "PAIR"
                                },
                                {
                                  prim: "FAILWITH"
                                }
                              ],
                              [
                                {
                                  prim: "DUP",
                                  args: [
                                    {
                                      int: "6"
                                    }
                                  ]
                                },
                                {
                                  prim: "EMPTY_SET",
                                  args: [
                                    {
                                      prim: "address"
                                    }
                                  ]
                                },
                                {
                                  prim: "PUSH",
                                  args: [
                                    {
                                      prim: "bool"
                                    },
                                    {
                                      prim: "True"
                                    }
                                  ]
                                },
                                {
                                  prim: "SENDER"
                                },
                                {
                                  prim: "UPDATE"
                                },
                                {
                                  prim: "DUP",
                                  args: [
                                    {
                                      int: "3"
                                    }
                                  ]
                                },
                                {
                                  prim: "PAIR"
                                },
                                {
                                  prim: "SOME"
                                },
                                {
                                  prim: "DUP",
                                  args: [
                                    {
                                      int: "7"
                                    }
                                  ]
                                },
                                {
                                  prim: "UPDATE"
                                },
                                {
                                  prim: "DIP",
                                  args: [
                                    {
                                      int: "1"
                                    },
                                    [
                                      {
                                        prim: "DIG",
                                        args: [
                                          {
                                            int: "5"
                                          }
                                        ]
                                      },
                                      {
                                        prim: "DROP",
                                        args: [
                                          {
                                            int: "1"
                                          }
                                        ]
                                      }
                                    ]
                                  ]
                                },
                                {
                                  prim: "DUG",
                                  args: [
                                    {
                                      int: "5"
                                    }
                                  ]
                                }
                              ]
                            ]
                          },
                          {
                            prim: "DROP",
                            args: [
                              {
                                int: "1"
                              }
                            ]
                          },
                          {
                            prim: "PAIR",
                            args: [
                              {
                                int: "6"
                              }
                            ]
                          },
                          {
                            prim: "DIG",
                            args: [
                              {
                                int: "1"
                              }
                            ]
                          },
                          {
                            prim: "PAIR"
                          }
                        ],
                        [
                          {
                            prim: "DUP",
                            args: [
                              {
                                int: "6"
                              }
                            ]
                          },
                          {
                            prim: "DUP",
                            args: [
                              {
                                int: "2"
                              }
                            ]
                          },
                          {
                            prim: "GET"
                          },
                          {
                            prim: "IF_NONE",
                            args: [
                              [
                                {
                                  prim: "PUSH",
                                  args: [
                                    {
                                      prim: "string"
                                    },
                                    {
                                      string: "INVALID OP ID"
                                    }
                                  ]
                                },
                                {
                                  prim: "FAILWITH"
                                }
                              ],
                              []
                            ]
                          },
                          {
                            prim: "PUSH",
                            args: [
                              {
                                prim: "mutez"
                              },
                              {
                                int: "0"
                              }
                            ]
                          },
                          {
                            prim: "AMOUNT"
                          },
                          {
                            prim: "COMPARE"
                          },
                          {
                            prim: "EQ"
                          },
                          {
                            prim: "NOT"
                          },
                          {
                            prim: "IF",
                            args: [
                              [
                                {
                                  prim: "PUSH",
                                  args: [
                                    {
                                      prim: "string"
                                    },
                                    {
                                      string: "TO FUND CONTRACT, PLEASE USE THE DEFAULT ENTRYPOINT"
                                    }
                                  ]
                                },
                                {
                                  prim: "FAILWITH"
                                }
                              ],
                              []
                            ]
                          },
                          {
                            prim: "DUP",
                            args: [
                              {
                                int: "4"
                              }
                            ]
                          },
                          {
                            prim: "SENDER"
                          },
                          {
                            prim: "MEM"
                          },
                          {
                            prim: "NOT"
                          },
                          {
                            prim: "IF",
                            args: [
                              [
                                {
                                  prim: "PUSH",
                                  args: [
                                    {
                                      prim: "string"
                                    },
                                    {
                                      string: "ONLY FOR SIGNERS"
                                    }
                                  ]
                                },
                                {
                                  prim: "FAILWITH"
                                }
                              ],
                              []
                            ]
                          },
                          {
                            prim: "DUP"
                          },
                          {
                            prim: "CDR"
                          },
                          {
                            prim: "SENDER"
                          },
                          {
                            prim: "MEM"
                          },
                          {
                            prim: "IF",
                            args: [
                              [
                                {
                                  prim: "PUSH",
                                  args: [
                                    {
                                      prim: "string"
                                    },
                                    {
                                      string: "ALREADY APPROVED"
                                    }
                                  ]
                                },
                                {
                                  prim: "FAILWITH"
                                }
                              ],
                              []
                            ]
                          },
                          {
                            prim: "DUP",
                            args: [
                              {
                                int: "7"
                              }
                            ]
                          },
                          {
                            prim: "DUP",
                            args: [
                              {
                                int: "8"
                              }
                            ]
                          },
                          {
                            prim: "DUP",
                            args: [
                              {
                                int: "4"
                              }
                            ]
                          },
                          {
                            prim: "GET"
                          },
                          {
                            prim: "IF_NONE",
                            args: [
                              [
                                {
                                  prim: "PUSH",
                                  args: [
                                    {
                                      prim: "string"
                                    },
                                    {
                                      string: "pending_ops"
                                    }
                                  ]
                                },
                                {
                                  prim: "PUSH",
                                  args: [
                                    {
                                      prim: "string"
                                    },
                                    {
                                      string: "ASSET_NOT_FOUND"
                                    }
                                  ]
                                },
                                {
                                  prim: "PAIR"
                                },
                                {
                                  prim: "FAILWITH"
                                }
                              ],
                              []
                            ]
                          },
                          {
                            prim: "UNPAIR"
                          },
                          {
                            prim: "SWAP"
                          },
                          {
                            prim: "DROP",
                            args: [
                              {
                                int: "1"
                              }
                            ]
                          },
                          {
                            prim: "DUP",
                            args: [
                              {
                                int: "9"
                              }
                            ]
                          },
                          {
                            prim: "DUP",
                            args: [
                              {
                                int: "5"
                              }
                            ]
                          },
                          {
                            prim: "GET"
                          },
                          {
                            prim: "IF_NONE",
                            args: [
                              [
                                {
                                  prim: "PUSH",
                                  args: [
                                    {
                                      prim: "string"
                                    },
                                    {
                                      string: "pending_ops"
                                    }
                                  ]
                                },
                                {
                                  prim: "PUSH",
                                  args: [
                                    {
                                      prim: "string"
                                    },
                                    {
                                      string: "ASSET_NOT_FOUND"
                                    }
                                  ]
                                },
                                {
                                  prim: "PAIR"
                                },
                                {
                                  prim: "FAILWITH"
                                }
                              ],
                              []
                            ]
                          },
                          {
                            prim: "CDR"
                          },
                          {
                            prim: "PUSH",
                            args: [
                              {
                                prim: "bool"
                              },
                              {
                                prim: "True"
                              }
                            ]
                          },
                          {
                            prim: "SENDER"
                          },
                          {
                            prim: "UPDATE"
                          },
                          {
                            prim: "SWAP"
                          },
                          {
                            prim: "PAIR"
                          },
                          {
                            prim: "SOME"
                          },
                          {
                            prim: "DUP",
                            args: [
                              {
                                int: "4"
                              }
                            ]
                          },
                          {
                            prim: "UPDATE"
                          },
                          {
                            prim: "DIP",
                            args: [
                              {
                                int: "1"
                              },
                              [
                                {
                                  prim: "DIG",
                                  args: [
                                    {
                                      int: "6"
                                    }
                                  ]
                                },
                                {
                                  prim: "DROP",
                                  args: [
                                    {
                                      int: "1"
                                    }
                                  ]
                                }
                              ]
                            ]
                          },
                          {
                            prim: "DUG",
                            args: [
                              {
                                int: "6"
                              }
                            ]
                          },
                          {
                            prim: "DROP",
                            args: [
                              {
                                int: "2"
                              }
                            ]
                          },
                          {
                            prim: "PAIR",
                            args: [
                              {
                                int: "6"
                              }
                            ]
                          },
                          {
                            prim: "DIG",
                            args: [
                              {
                                int: "1"
                              }
                            ]
                          },
                          {
                            prim: "PAIR"
                          }
                        ]
                      ]
                    }
                  ]
                ]
              }
            ],
            [
              {
                prim: "DUP",
                args: [
                  {
                    int: "6"
                  }
                ]
              },
              {
                prim: "DUP",
                args: [
                  {
                    int: "2"
                  }
                ]
              },
              {
                prim: "GET"
              },
              {
                prim: "IF_NONE",
                args: [
                  [
                    {
                      prim: "PUSH",
                      args: [
                        {
                          prim: "string"
                        },
                        {
                          string: "INVALID OP ID"
                        }
                      ]
                    },
                    {
                      prim: "FAILWITH"
                    }
                  ],
                  []
                ]
              },
              {
                prim: "PUSH",
                args: [
                  {
                    prim: "mutez"
                  },
                  {
                    int: "0"
                  }
                ]
              },
              {
                prim: "AMOUNT"
              },
              {
                prim: "COMPARE"
              },
              {
                prim: "EQ"
              },
              {
                prim: "NOT"
              },
              {
                prim: "IF",
                args: [
                  [
                    {
                      prim: "PUSH",
                      args: [
                        {
                          prim: "string"
                        },
                        {
                          string: "TO FUND CONTRACT, PLEASE USE THE DEFAULT ENTRYPOINT"
                        }
                      ]
                    },
                    {
                      prim: "FAILWITH"
                    }
                  ],
                  []
                ]
              },
              {
                prim: "DUP",
                args: [
                  {
                    int: "4"
                  }
                ]
              },
              {
                prim: "SENDER"
              },
              {
                prim: "MEM"
              },
              {
                prim: "NOT"
              },
              {
                prim: "IF",
                args: [
                  [
                    {
                      prim: "PUSH",
                      args: [
                        {
                          prim: "string"
                        },
                        {
                          string: "ONLY FOR SIGNERS"
                        }
                      ]
                    },
                    {
                      prim: "FAILWITH"
                    }
                  ],
                  []
                ]
              },
              {
                prim: "DUP",
                args: [
                  {
                    int: "5"
                  }
                ]
              },
              {
                prim: "DUP",
                args: [
                  {
                    int: "2"
                  }
                ]
              },
              {
                prim: "CDR"
              },
              {
                prim: "SIZE"
              },
              {
                prim: "COMPARE"
              },
              {
                prim: "GE"
              },
              {
                prim: "NOT"
              },
              {
                prim: "IF",
                args: [
                  [
                    {
                      prim: "PUSH",
                      args: [
                        {
                          prim: "string"
                        },
                        {
                          string: "NOT YET APPROVED"
                        }
                      ]
                    },
                    {
                      prim: "FAILWITH"
                    }
                  ],
                  []
                ]
              },
              {
                prim: "DUP",
                args: [
                  {
                    int: "7"
                  }
                ]
              },
              {
                prim: "DUP",
                args: [
                  {
                    int: "3"
                  }
                ]
              },
              {
                prim: "GET"
              },
              {
                prim: "IF_NONE",
                args: [
                  [
                    {
                      prim: "PUSH",
                      args: [
                        {
                          prim: "string"
                        },
                        {
                          string: "pending_ops"
                        }
                      ]
                    },
                    {
                      prim: "PUSH",
                      args: [
                        {
                          prim: "string"
                        },
                        {
                          string: "ASSET_NOT_FOUND"
                        }
                      ]
                    },
                    {
                      prim: "PAIR"
                    },
                    {
                      prim: "FAILWITH"
                    }
                  ],
                  []
                ]
              },
              {
                prim: "CAR"
              },
              {
                prim: "PUSH",
                args: [
                  {
                    prim: "unit"
                  },
                  {
                    prim: "Unit"
                  }
                ]
              },
              {
                prim: "EXEC"
              },
              {
                prim: "DIP",
                args: [
                  {
                    int: "1"
                  },
                  [
                    {
                      prim: "DIG",
                      args: [
                        {
                          int: "8"
                        }
                      ]
                    },
                    {
                      prim: "DROP",
                      args: [
                        {
                          int: "1"
                        }
                      ]
                    }
                  ]
                ]
              },
              {
                prim: "DUG",
                args: [
                  {
                    int: "8"
                  }
                ]
              },
              {
                prim: "DUP",
                args: [
                  {
                    int: "7"
                  }
                ]
              },
              {
                prim: "NONE",
                args: [
                  {
                    prim: "pair",
                    args: [
                      {
                        prim: "lambda",
                        args: [
                          {
                            prim: "unit"
                          },
                          {
                            prim: "list",
                            args: [
                              {
                                prim: "operation"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        prim: "set",
                        args: [
                          {
                            prim: "address"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                prim: "DUP",
                args: [
                  {
                    int: "4"
                  }
                ]
              },
              {
                prim: "UPDATE"
              },
              {
                prim: "DIP",
                args: [
                  {
                    int: "1"
                  },
                  [
                    {
                      prim: "DIG",
                      args: [
                        {
                          int: "6"
                        }
                      ]
                    },
                    {
                      prim: "DROP",
                      args: [
                        {
                          int: "1"
                        }
                      ]
                    }
                  ]
                ]
              },
              {
                prim: "DUG",
                args: [
                  {
                    int: "6"
                  }
                ]
              },
              {
                prim: "DROP",
                args: [
                  {
                    int: "2"
                  }
                ]
              },
              {
                prim: "PAIR",
                args: [
                  {
                    int: "6"
                  }
                ]
              },
              {
                prim: "DIG",
                args: [
                  {
                    int: "1"
                  }
                ]
              },
              {
                prim: "PAIR"
              }
            ]
          ]
        }
      ]
    ]
  }
];
var makeStorageJSON = (owner, signers, threshold) => ({
  owner,
  signers,
  threshold,
  last_op_id: "0",
  pending_ops: [],
  metadata: []
});

// src/decoding.ts
import { encodeAddress } from "@taquito/utils";
import { parseContractPkh, parseImplicitPkh, parsePkh } from "@umami/tezos";

// src/schemas.ts
import { z } from "zod";
var caseInsensitiveLiteral = (label) => z.string().regex(new RegExp(`^${label}$`, "i"));
var prim = (label) => z.object({
  prim: caseInsensitiveLiteral(label)
});
var pushKeyHashSchema = z.object({
  prim: z.literal("PUSH"),
  args: z.tuple([z.object({ prim: z.literal("key_hash") }), z.object({ bytes: z.string() })])
});
var pushAddressSchema = z.object({
  prim: z.literal("PUSH"),
  args: z.tuple([z.object({ prim: z.literal("address") }), z.object({ bytes: z.string() })])
});
var pair = (first, second) => z.object({
  prim: z.literal("Pair"),
  args: z.tuple([first, second])
});
var contractZeroTezSchema = z.object({
  prim: z.literal("PUSH"),
  args: z.tuple([z.object({ prim: z.literal("mutez") }), z.object({ int: z.literal("0") })])
});
var lambdaEndSchema = [prim("TRANSFER_TOKENS"), prim("CONS")];
var contractHeadSchema = z.object({
  prim: z.literal("CONTRACT")
});
var batchHeadSchema = z.tuple([
  z.object({
    prim: z.literal("DROP")
  }),
  z.object({
    prim: z.literal("NIL"),
    args: z.array(
      z.object({
        prim: z.literal("operation")
      })
    )
  })
]);
var pushMutezSchema = z.object({
  prim: z.literal("PUSH"),
  args: z.tuple([z.object({ prim: z.literal("mutez") }), z.object({ int: z.string() })])
});
var tezSchema = z.tuple([
  pushKeyHashSchema,
  prim("IMPLICIT_ACCOUNT"),
  pushMutezSchema,
  prim("UNIT"),
  ...lambdaEndSchema
]);
var contractTezSchema = z.tuple([
  pushAddressSchema,
  contractHeadSchema,
  prim("IF_NONE"),
  pushMutezSchema,
  prim("UNIT"),
  ...lambdaEndSchema
]);
var setDelegateSchema = z.tuple([
  pushKeyHashSchema,
  prim("SOME"),
  prim("SET_DELEGATE"),
  prim("CONS")
]);
var removeDelegateSchema = z.tuple([
  z.object({
    prim: z.literal("NONE"),
    args: z.tuple([z.object({ prim: z.literal("key_hash") })])
  }),
  prim("SET_DELEGATE"),
  prim("CONS")
]);
var fa2Schema = z.tuple([
  pushAddressSchema,
  contractHeadSchema,
  z.tuple([prim("IF_NONE")]),
  contractZeroTezSchema,
  z.object({
    prim: z.literal("PUSH"),
    args: z.tuple([
      prim("list"),
      // arg types
      // FA2 allows to include a few transactions in a batch
      z.array(
        pair(
          z.object({ bytes: z.string({ description: "from" }) }),
          z.array(
            pair(
              z.object({ bytes: z.string({ description: "to" }) }),
              pair(
                z.object({ int: z.string({ description: "token_id" }) }),
                z.object({ int: z.string({ description: "amount" }) })
              )
            )
          )
        )
      )
    ])
  }),
  ...lambdaEndSchema
]);
var fa1Schema = z.tuple([
  pushAddressSchema,
  contractHeadSchema,
  z.tuple([prim("IF_NONE")]),
  contractZeroTezSchema,
  z.object({
    prim: z.literal("PUSH"),
    args: z.tuple([
      prim("Pair"),
      // arg types
      pair(
        z.object({ bytes: z.string({ description: "from" }) }),
        pair(
          z.object({ bytes: z.string({ description: "to" }) }),
          z.object({ int: z.string({ description: "amount" }) })
        )
      )
    ])
  }),
  ...lambdaEndSchema
]);

// src/UnrecognizedMichelsonError.ts
var UnrecognizedMichelsonError = class extends Error {
};

// src/decoding.ts
var convertToPkh = (addressBytes) => {
  if (addressBytes.length === 42) {
    addressBytes = "00" + addressBytes;
  }
  return encodeAddress(addressBytes);
};
var parseTez = (michelson) => {
  const parseResult = tezSchema.parse(michelson);
  const to = parseResult[0].args[1].bytes;
  const amount = parseResult[2].args[1].int;
  return {
    type: "tez",
    recipient: parseImplicitPkh(convertToPkh(to)),
    amount
  };
};
var parseTezContract = (michelson) => {
  const parseResult = contractTezSchema.parse(michelson);
  const to = parseResult[0].args[1].bytes;
  const amount = parseResult[3].args[1].int;
  return {
    type: "tez",
    recipient: parseContractPkh(convertToPkh(to)),
    amount
  };
};
var parseFa2 = (michelson) => {
  const parseResult = fa2Schema.parse(michelson);
  const contractAddress = parseContractPkh(convertToPkh(parseResult[0].args[1].bytes));
  const operations = parseResult[4].args[1];
  return operations.flatMap((operation) => {
    const from = operation.args[0].bytes;
    return operation.args[1].map((destination) => {
      const to = destination.args[0].bytes;
      const tokenId = destination.args[1].args[0].int;
      const amount = destination.args[1].args[1].int;
      return {
        type: "fa2",
        contract: contractAddress,
        sender: parsePkh(convertToPkh(from)),
        recipient: parsePkh(convertToPkh(to)),
        tokenId,
        amount
      };
    });
  });
};
var parseFa1 = (michelson) => {
  const parseResult = fa1Schema.parse(michelson);
  const lambdaRecipient = parseResult[0];
  const entrypointArgs = parseResult[4].args[1];
  const from = entrypointArgs.args[0].bytes;
  const to = entrypointArgs.args[1].args[0].bytes;
  const amount = entrypointArgs.args[1].args[1].int;
  return {
    type: "fa1.2",
    amount,
    contract: parseContractPkh(convertToPkh(lambdaRecipient.args[1].bytes)),
    recipient: parsePkh(convertToPkh(to)),
    sender: parsePkh(convertToPkh(from)),
    tokenId: "0"
  };
};
var parseSetDelegate = (michelson, account) => {
  const parseResult = setDelegateSchema.parse(michelson);
  return {
    type: "delegation",
    sender: account.address,
    recipient: parseImplicitPkh(convertToPkh(parseResult[0].args[1].bytes))
  };
};
var parseRemoveDelegate = (_michelson, account) => ({ type: "undelegation", sender: account.address });
var parsings = [
  { schema: tezSchema, parsingFn: parseTez },
  { schema: contractTezSchema, parsingFn: parseTezContract },
  { schema: fa2Schema, parsingFn: parseFa2 },
  { schema: fa1Schema, parsingFn: parseFa1 },
  { schema: setDelegateSchema, parsingFn: parseSetDelegate },
  { schema: removeDelegateSchema, parsingFn: parseRemoveDelegate }
];
var parse = (michelson, account, acc = []) => {
  if (michelson.length === 0) {
    return acc;
  }
  for (let i = 0; i < parsings.length; i++) {
    const { schema, parsingFn } = parsings[i];
    const parseResult = schema.safeParse(michelson.slice(0, schema.items.length));
    if (!parseResult.success) {
      continue;
    }
    const parsed = parsingFn(parseResult.data, account);
    return parse(michelson.slice(schema.items.length), account, [...acc, ...[parsed].flat()]);
  }
  throw new UnrecognizedMichelsonError(`${JSON.stringify(michelson[0])}`);
};
var assertHead = (michelson) => {
  batchHeadSchema.parse(michelson.slice(0, 2));
};
var decode = (michelson, account) => {
  assertHead(michelson);
  return parse(michelson.slice(2), account);
};
var parseRawMichelson = (rawMichelson, account) => {
  const michelson = JSON.parse(rawMichelson);
  return decode(michelson, account);
};

// src/fetch.ts
import { contractsGet, contractsGetCount } from "@tzkt/sdk-api";
import { withRateLimit } from "@umami/tzkt";
import range from "lodash/range";
import sortBy from "lodash/sortBy";
var TYPE_HASH = 1963879877;
var CODE_HASH = -1890025422;
var MULTISIG_QUERY = {
  kind: { eq: "smart_contract" },
  typeHash: { eq: TYPE_HASH },
  codeHash: { eq: CODE_HASH }
};
var LIMIT = 1e4;
var getAllMultisigContracts = async (network) => {
  const count = await withRateLimit(
    () => contractsGetCount(MULTISIG_QUERY, { baseUrl: network.tzktApiUrl })
  );
  const batches = await Promise.all(
    range(Math.ceil(count / LIMIT)).map(
      (index) => withRateLimit(
        () => contractsGet(
          {
            ...MULTISIG_QUERY,
            includeStorage: true,
            limit: LIMIT,
            offset: { pg: index },
            select: { fields: [["id", "address", "storage"].join(",")] }
          },
          {
            baseUrl: network.tzktApiUrl
          }
        )
      )
    )
  );
  return sortBy(batches.flat(), "id");
};
var getExistingContracts = (pkhs, network) => withRateLimit(
  () => contractsGet(
    {
      address: { in: [pkhs.join(",")] },
      select: { fields: ["address"] },
      limit: Math.min(LIMIT, pkhs.length)
    },
    {
      baseUrl: network.tzktApiUrl
    }
  )
);
var getPendingOperationsForMultisigs = async (bigMaps, network) => withRateLimit(async () => {
  if (bigMaps.length === 0) {
    return Promise.resolve([]);
  }
  const url = `${network.tzktApiUrl}/v1/bigmaps/keys?active=true&bigmap.in=${bigMaps.join(
    ","
  )}&limit=10000`;
  return fetch(url).then((res) => res.json());
});

// src/helpers.ts
import {
  isValidImplicitPkh,
  parseContractPkh as parseContractPkh2,
  parseImplicitPkh as parseImplicitPkh2
} from "@umami/tezos";
import { CustomError } from "@umami/utils";
import { compact, every } from "lodash";
var parseMultisig = (raw) => ({
  address: parseContractPkh2(raw.address),
  threshold: Number(raw.storage.threshold),
  signers: raw.storage.signers.map(parseImplicitPkh2),
  pendingOperationsBigmapId: raw.storage.pending_ops
});
var getRelevantMultisigContracts = async (accountPkhs, network) => {
  const multisigs = await getAllMultisigContracts(network);
  return multisigs.filter(({ storage: { signers } }) => {
    if (!every(signers, isValidImplicitPkh)) {
      return false;
    }
    const intersection = signers.filter((signer) => accountPkhs.has(signer));
    return intersection.length > 0;
  }).map(parseMultisig);
};
var getNetworksForContracts = async (availableNetworks, contractPkhs) => {
  const result = /* @__PURE__ */ new Map();
  if (contractPkhs.length === 0) {
    return result;
  }
  const accountsWithNetwork = await Promise.all(
    availableNetworks.map(
      async (network) => (await getExistingContracts(contractPkhs, network)).map((contractPkh) => [
        contractPkh,
        network.name
      ])
    )
  );
  accountsWithNetwork.flat().forEach(([pkh, network]) => result.set(pkh, network));
  return result;
};
var parseMultisigOperation = (raw) => {
  const { bigmap, key, value } = raw;
  if (key === null || value === null) {
    throw new CustomError("parseMultisigOperation failed");
  }
  return {
    id: key,
    bigmapId: bigmap,
    rawActions: value.actions,
    // For now, we assume the approver is always an implicit account
    approvals: value.approvals?.map(parseImplicitPkh2) ?? []
  };
};
var getPendingOperations = async (multisigs, network) => {
  if (multisigs.length === 0) {
    return [];
  }
  const bigmapIds = multisigs.map((m) => m.pendingOperationsBigmapId);
  const response = await getPendingOperationsForMultisigs(bigmapIds, network);
  return compact(response.map(parseMultisigOperation));
};

// src/testUtils.ts
import { mockContractAddress, mockImplicitAddress } from "@umami/tezos";
var mockMultisigWithOperations = (index, signers = [], threshold = 3) => ({
  address: mockContractAddress(index),
  pendingOperationsBigmapId: index,
  signers: signers.map((pkh) => ({ type: "implicit", pkh })),
  threshold
});
var multisigsFixture = [
  {
    address: { pkh: "KT1NYUDvzv85i4558nbgUEpMY8thJG3XDSeB", type: "contract" },
    threshold: 2,
    signers: [mockImplicitAddress(3)],
    pendingOperationsBigmapId: 0
  },
  {
    address: { pkh: "KT1JG7wmGuXi7Sdf3eqATscVmhqyyT3Q8Xjg", type: "contract" },
    threshold: 1,
    signers: [mockImplicitAddress(1), mockImplicitAddress(2)],
    pendingOperationsBigmapId: 0
  },
  {
    address: { pkh: "KT1FDgmFVfKe19nk73nA8sTmW8rE1WUahG3K", type: "contract" },
    threshold: 1,
    signers: [
      { pkh: "tz1Te4MXuNYxyyuPqmAQdnKwkD8ZgSF9M7d6", type: "implicit" },
      { pkh: "tz1UNer1ijeE9ndjzSszRduR3CzX49hoBUB3", type: "implicit" }
    ],
    pendingOperationsBigmapId: 0
  }
];
var multisigOperationFixture = {
  id: "1",
  bigmapId: 0,
  rawActions: '[{"prim":"DROP"},{"prim":"NIL","args":[{"prim":"operation"}]},{"prim":"PUSH","args":[{"prim":"key_hash"},{"bytes":"005fd0a7ece135cecfd71fcf78cf6656d5047fb980"}]},{"prim":"IMPLICIT_ACCOUNT"},{"prim":"PUSH","args":[{"prim":"mutez"},{"int":"100000"}]},{"prim":"UNIT"},{"prim":"TRANSFER_TOKENS"},{"prim":"CONS"}]',
  approvals: [{ type: "implicit", pkh: "pkh" }]
};
var multisigPendingOpsFixtures = [
  {
    id: "1",
    rawActions: '[{"prim":"DROP"},{"prim":"NIL","args":[{"prim":"operation"}]},{"prim":"PUSH","args":[{"prim":"key_hash"},{"bytes":"00e09454275ac1a764ca6f8b1f52a2eeff1fd4fe0e"}]},{"prim":"IMPLICIT_ACCOUNT"},{"prim":"PUSH","args":[{"prim":"mutez"},{"int":"1000000"}]},{"prim":"UNIT"},{"prim":"TRANSFER_TOKENS"},{"prim":"CONS"}]',
    approvals: [{ type: "implicit", pkh: "tz1UNer1ijeE9ndjzSszRduR3CzX49hoBUB3" }],
    bigmapId: 3
  },
  {
    id: "2",
    rawActions: '[{"prim":"DROP"},{"prim":"NIL","args":[{"prim":"operation"}]},{"prim":"PUSH","args":[{"prim":"key_hash"},{"bytes":"0057c264d6d7f7257cd3d8096150b0d8be60577ca7"}]},{"prim":"IMPLICIT_ACCOUNT"},{"prim":"PUSH","args":[{"prim":"mutez"},{"int":"3000000"}]},{"prim":"UNIT"},{"prim":"TRANSFER_TOKENS"},{"prim":"CONS"}]',
    approvals: [{ type: "implicit", pkh: "tz1UNer1ijeE9ndjzSszRduR3CzX49hoBUB3" }],
    bigmapId: 3
  }
];
export {
  CODE_HASH,
  TYPE_HASH,
  UnrecognizedMichelsonError,
  contract,
  decode,
  getAllMultisigContracts,
  getExistingContracts,
  getNetworksForContracts,
  getPendingOperations,
  getPendingOperationsForMultisigs,
  getRelevantMultisigContracts,
  makeStorageJSON,
  mockMultisigWithOperations,
  multisigOperationFixture,
  multisigPendingOpsFixtures,
  multisigsFixture,
  parseMultisig,
  parseRawMichelson
};
